<script setup lang="ts">
	import {useFavoriteProductStore} from '@/store/favorite.product.store';
	import {storeToRefs} from 'pinia';
	import {useAppStore} from '@/store/app.store';
	import {useFilters} from '@/store/filter.store';

	const emit = defineEmits(['favorites-toggled']);

	const appStore = useAppStore();
	const filterStore = useFilters();
	const favoriteStore = useFavoriteProductStore();
	const {favoriteAmount, favoriteViewActive} = storeToRefs(favoriteStore);

	const toggleFavoriteView = () => {
		if (!favoriteViewActive.value) {
			appStore.setFilterBlockActive(true);
		}

		favoriteStore.toggleFavoriteView();

		filterStore.resetFilters();

		emit('favorites-toggled');
	};
</script>

<template>
	<button :class="[!favoriteViewActive && favoriteAmount === 0 ? 'disabled' : '']"
	        :disabled="!favoriteViewActive && favoriteAmount === 0"
	        class="catalog-overview-header__favorites ml-1_5"
	        type="button"
	        @click="toggleFavoriteView">

		<svg width="20" height="19" :class="favoriteViewActive ? 'icon-star' : 'icon-star-open'">
			<use v-if="favoriteViewActive" xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#star"></use>
			<use v-else xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#star-open"></use>
		</svg>
		<span v-if="favoriteAmount > 0">&nbsp;({{ favoriteAmount }})</span>
	</button>
</template>
